module.exports = __webpack_public_path__ + "img/banner_tr.f1c3d8bb.jpg";